// Format - DD/MM/YYYY (JS Date default is MM/DD/YYYY which causes issues with the
// Date object in Ruby which formats dates as DD/MM/YYYY by default)
export const formatDate = dateString => {
  const dateParts = dateString.split('/')

  // month is 0-based hence dateParts[1] - 1
  return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0])
}
